import React, { useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useAuthStore } from "@/store/use-auth-store";
import { useGetAllUsers } from "@/hooks/user/use-user";
import { useGetApplicationsForProcess } from "@/hooks/process";
import { ProcessDetailList } from "@/components/process";

const PendingProcesses: React.FC = () => {
  const { user } = useAuthStore();
  const { t } = useTranslation();
  const { processId } = useParams();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  if (!processId || !user?.id) {
    return <p className="mt-8 text-center text-primary">{t('processManagement.loading')}</p>;
  }

  const { data: responseData, isLoading, isError } = useGetApplicationsForProcess(
    processId as string,
    'pending',
    false,
    undefined,
    { page, limit: 20, search: search || undefined }
  );

  const { data: users = [] } = useGetAllUsers();
  const data = responseData?.data || [];
  const meta = responseData?.meta;

  const handleSearchChange = useCallback((s: string) => {
    setSearch(s);
    setPage(1);
  }, []);

  return (
    <ProcessDetailList
      data={data}
      isLoading={isLoading}
      isError={isError}
      processId={processId}
      title={t('processManagement.pendingApplications')}
      loadingMessage={t('processManagement.loading')}
      errorMessage={t('processManagement.errorLoadingData')}
      noDataMessage={t('processManagement.noPendingApplicationsFound')}
      baseRoute="/staff/incoming/pending-applications"
      showEditButton={true}
      users={users}
      meta={meta}
      onPageChange={setPage}
      search={search}
      onSearchChange={handleSearchChange}
    />
  );
};

export default PendingProcesses;
